import PropTypes from "prop-types";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const EmptyState = ({ onSetup }) => {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto"
      data-testid="polls-empty-state">
      <WebIcon
        icon="PollsHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="heading-large whitespace-nowrap font-bold text-lighterGrey mb-4">
        Polls and Surveys Empty
      </h2>
      <p className="text-bold-x font-normal text-lighterGrey mb-8">
        There&apos;s nothing to show here.
      </p>
      <Button
        text="CREATE NEW POLL"
        color="primary"
        className="w-full px-6 py-3 text-white font-medium"
        customBgColor="primary"
        customTextColor="white"
        onClick={onSetup}
      />
    </div>
  );
};

EmptyState.propTypes = {
  onSetup: PropTypes.func,
};

export default EmptyState;
